<template>
  <div class="nav-container" :class="{
    'home': miniMode,
    'not-home': !miniMode,
    'initializing': pageState.initializing,
    'hide': hide,
  }">
    <nav v-if="isAuth && !route.params.code" class="py-0 navbar fixed-top up-nav" :class="{
      scrolled: true,
    }">
      <router-link class="navbar-brand" :class="{ 'mobile-opacity-0': pageState.expanded }" to="/">
        <img class="nav-img" width="100" height="100" src="~@/assets/images/logo_green.svg" />

      </router-link>

      <div class="header-nav-right position-relative me-3 d-flex align-items-center">
        <ul class="nav d-flex me-4">
          <li class="nav-item">
            <router-link class="py-0 nav-link" to="/my-workouts">
              <span>My activity</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="py-0 nav-link" to="/book-workout">
              <span>Live schedule</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="py-0 nav-link" to="/on-demand">
              <span>On Demand</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="py-0 nav-link" to="/all-workouts">
              <span>All Workouts</span>
            </router-link>
          </li>
        </ul>
        <div class="user-actions" :class="{ expand: pageState.expanded }" @click="toggleAction">
          <span class="level-up-icon" :class="[`level-up-icon-${user?.level}`]">
            <SvgIcon :name="`Level-${user?.level}`" />
          </span>
          <i class="text-white fa-regular fa-angle-down"></i>
        </div>
        <div class="expand-icon" @click="toggleExpand">
          <i class="nav-expand-btn" :class="{ expand: pageState.expanded }">
            <span></span>
          </i>
        </div>
      </div>

      <div id="navbar-toggle-collapse" class="collapse up-nav-collapse" is-nav>
        <ul class="ml-auto navbar-nav"></ul>
      </div>
    </nav>

    <ProfileInfo v-if="pageState.expanded" />

    <div v-if="!isAuth" class="logged-out-nav" :class="{
      'scrolled-more': pageState.scrolledMore,
      'scrolled': pageState.scrolled,
      'no-auth-bg': route.name === 'workout-detail',
    }">

      <i v-if="!pageState.public_expanded" @click="pageState.public_expanded = true"
        class="mobile-only open-nav-icon fa-sharp fa-regular fa-bars"></i>

      <ul class="user-controls" style="display: none;"></ul>


      <div class="floating-nav">
        <div class="floating-nav-inner">

          <router-link class="mobile-only navbar-logo" :class="{ 'mobile-opacity-0': pageState.expanded }" to="/">
            <img class="nav-img" src="~@/assets/images/home/home-logo-full-000000.svg" />
          </router-link>

          <router-link class="desktop-only floating-nav-logo" to="/">
            <img src="~@/assets/images/home/home-logo-full-000000.svg" />
          </router-link>

          <div class="outer-login-btn" style="display: none;"></div>

          <nav :class="{
            'expanded': pageState.public_expanded,
          }">
            <i v-if="pageState.public_expanded" @click="pageState.public_expanded = false"
              class="mobile-only close-nav-icon fa-sharp fa-regular fa-xmark"></i>
            <ul>
              <li class="nav-item has-dropdown" @mouseenter="showMegaMenu('product')" @mouseleave="scheduleMegaMenuHide">
                <span class="nav-link-text">Product</span>
                <div class="nav-dropdown">
                  <router-link to="/product-overview" @click="pageState.public_expanded = false">Overview</router-link>
                  <router-link to="/product-mental-fitness-gym" @click="pageState.public_expanded = false">Mental Fitness Gym</router-link>
                  <router-link to="/product-mental-fitness-games" @click="pageState.public_expanded = false">Mental Fitness Games</router-link>
                  <router-link to="/product-mental-fitness-academy" @click="pageState.public_expanded = false">Mental Fitness Academy</router-link>
                  <router-link to="/product-overview#performance-intelligence" @click="pageState.public_expanded = false">Mental Performance Index&trade;</router-link>
                </div>
              </li>
              <li class="nav-item has-dropdown" @mouseenter="showMegaMenu('solutions')" @mouseleave="scheduleMegaMenuHide">
                <span class="nav-link-text">Solutions</span>
                <div class="nav-dropdown">
                  <router-link to="/customer-stories#testimonials" @click="pageState.public_expanded = false">Business Services</router-link>
                  <router-link to="/customer-stories#testimonials" @click="pageState.public_expanded = false">Consumer</router-link>
                  <router-link to="/customer-stories#testimonials" @click="pageState.public_expanded = false">Financial Services</router-link>
                  <router-link to="/customer-stories#testimonials" @click="pageState.public_expanded = false">Tech</router-link>
                  <router-link to="/customer-stories#testimonials" @click="pageState.public_expanded = false">Hospitality</router-link>
                  <router-link class="hide-mobile" to="/product-overview" @click="pageState.public_expanded = false">Product</router-link>
                  <router-link class="hide-mobile" to="/product-overview#scale" @click="pageState.public_expanded = false">Team</router-link>
                  <router-link class="hide-mobile" to="/product-overview#offerings" @click="pageState.public_expanded = false">Enterprise</router-link>
                </div>
              </li>
              <li class="nav-item" @mouseenter="hideMegaMenuNow">
                <router-link class="nav-link-text" to="/customer-stories" @click="pageState.public_expanded = false">Customers</router-link>
              </li>
              <li class="nav-item" @mouseenter="hideMegaMenuNow">
                <router-link class="nav-link-text" to="/about-us" @click="pageState.public_expanded = false">About Us</router-link>
              </li>
              <li class="nav-item nav-login" @mouseenter="hideMegaMenuNow">
                <router-link class="nav-link-text" @click="pageState.public_expanded = false" v-bind:to="'/login' + (route.query.redirect ? '?redirect=' + route.query.redirect : '')">
                  Log in
                </router-link>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <div class="mega-menu-overlay"
           :class="{ active: !!activeMegaMenu }"
           @mouseenter="cancelMegaMenuHide"
           @mouseleave="scheduleMegaMenuHide"
           @click.self="hideMegaMenuNow">
        <div class="mega-menu-container">
          <div v-if="currentMegaMenuData" class="mega-cols">
            <div class="mega-left">
              <div v-for="(subcol, i) in currentMegaMenuData.leftCols" :key="i" class="mega-subcol">
                <span class="mega-header">{{ subcol.header }}</span>
                <a v-for="(link, j) in subcol.links" :key="j"
                   :href="link.href"
                   class="mega-link"
                   @click.prevent="navigateAndClose(link.href)">
                  <span class="mega-link-title">{{ link.title }}</span>
                  <span v-if="link.desc" class="mega-link-desc">{{ link.desc }}</span>
                </a>
              </div>
            </div>
            <div v-if="currentMegaMenuData.rightCards && currentMegaMenuData.rightCards.length" class="mega-right">
              <span class="mega-header">{{ currentMegaMenuData.rightHeader }}</span>
              <div class="mega-cards">
                <a v-for="(card, k) in currentMegaMenuData.rightCards" :key="k"
                   :href="card.href"
                   class="mega-card"
                   @click.prevent="navigateAndClose(card.href)">
                  <div class="mega-card-thumb">
                    <img v-if="card.img" :src="card.img" :alt="card.title" />
                  </div>
                  <span class="mega-card-tag">{{ card.tag }}</span>
                  <span class="mega-card-title">{{ card.title }}</span>
                  <span v-if="card.subtitle" class="mega-card-subtitle">{{ card.subtitle }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script lang="ts" setup>
import SvgIcon from './SvgIcon.vue';
import ProfileInfo from '@/components/ProfileInfo.vue';

import { reactive, computed, onMounted, onBeforeUnmount, watch, ref } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { useRoute, useRouter } from 'vue-router';

function lockBodyScroll() {
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.inset = '0';
  document.body.style.width = '100%';
}

function unlockBodyScroll() {
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.inset = '';
  document.body.style.width = '';
}

const userStore = useUserStore();
const route = useRoute();
const router = useRouter();


const isAuth = computed(() => {
  return userStore.getAuthenticated;
});

const user = computed(() => {
  return userStore.getUser;
});

const miniMode = computed(() => {

  const miniModeViews = [
    'payment-step',
    'join',
    'forgotpwd',
    'reset-password',
    'rate-workout',
    'resetpwd',
    'waiting-list',
  ]

  if (miniModeViews.includes(route.name as string)) {
    return true;
  } else {
    return false;
  }
});

const hide = computed(() => {
  const hideViews = [
    'quiz',
    'payment-step',
  ]

  if (hideViews.includes(route.name as string)) {
    return true;
  } else {
    return false;
  }
});

const pageState = reactive({
  visible: false,
  scrolled: false,
  scrolledMore: false,
  navbarExpanded: false,
  public_expanded: false,
  pcExpanded: false,
  expanded: false,
  profileContracted: true,
  initializing: true,
});

const activeMegaMenu = ref<string | null>(null);
let megaMenuTimeout: ReturnType<typeof setTimeout> | null = null;

import featureImg1 from '@/assets/images/home/home-nav-feature1.jpg';
import featureImg2 from '@/assets/images/home/home-nav-feature2.jpg';
import featureImg3 from '@/assets/images/home/home-nav-feature3.jpg';
import featureImg4 from '@/assets/images/home/home-nav-feature4.jpg';

const megaMenuContent: Record<string, {
  leftCols: { header: string; links: { title: string; desc: string; href: string }[] }[];
  rightHeader: string;
  rightCards: { tag: string; title: string; subtitle?: string; href: string; img?: string }[];
}> = {
  product: {
    leftCols: [
      {
        header: 'Product',
        links: [
          { title: 'Overview', desc: 'The system for human performance', href: '/product-overview' },
          { title: 'Mental Fitness Gym', desc: 'Smarter training, better outcome.', href: '/product-mental-fitness-gym' },
          { title: 'Mental Fitness Games', desc: 'Train, connect, compete. Together.', href: '/product-mental-fitness-games' },
          { title: 'Mental Performance Index™', desc: 'Measure progress, improve performance', href: '/product-overview#performance-intelligence' },
        ],
      },
      {
        header: '　',
        links: [
          { title: 'Mental Fitness Academy', desc: 'Build performance at scale', href: '/product-mental-fitness-academy' },
          { title: 'Portal', desc: 'Insights & performance intelligence', href: '/product-overview#performance-intelligence' },
        ],
      },
    ],
    rightHeader: 'Product',
    rightCards: [
      { tag: 'Product Announcements', title: 'Mental Fitness Gym', subtitle: 'Book demo', href: '/product-mental-fitness-gym', img: featureImg1 },
      { tag: 'Product Announcements', title: 'Measure your strength', subtitle: 'Book demo', href: '/product-overview#performance-intelligence', img: featureImg2 },
    ],
  },
  solutions: {
    leftCols: [
      {
        header: 'By area',
        links: [
          { title: 'Business Services', desc: 'Confidence in high-stakes client work.', href: '/customer-stories#testimonials' },
          { title: 'Consumer', desc: 'Where experience shapes growth.', href: '/customer-stories#testimonials' },
          { title: 'Financial Services', desc: 'Sharper judgment where trust matters.', href: '/customer-stories#testimonials' },
          { title: 'Tech', desc: 'Clarity in complex, fast-moving environments.', href: '/customer-stories#testimonials' },
          { title: 'Hospitality', desc: 'Great service through strong people.', href: '/customer-stories#testimonials' },
        ],
      },
      {
        header: 'By type',
        links: [
          { title: 'Team', desc: 'Stronger performance together.', href: '/product-overview#scale' },
          { title: 'Enterprise', desc: 'Human performance at scale.', href: '/product-overview#offerings' },
        ],
      },
    ],
    rightHeader: 'Product',
    rightCards: [
      { tag: 'Product Announcements', title: 'Mental Fitness Event', subtitle: 'Book demo', href: '/product-overview#offerings', img: featureImg3 },
      { tag: 'Product Announcements', title: 'Enterprise Licenses', subtitle: 'Book demo', href: '/product-overview#enterprise-licenses', img: featureImg4 },
    ],
  },
};

const currentMegaMenuData = computed(() => {
  if (!activeMegaMenu.value) return null;
  return megaMenuContent[activeMegaMenu.value] || null;
});

const showMegaMenu = (menu: string) => {
  if (megaMenuTimeout) {
    clearTimeout(megaMenuTimeout);
    megaMenuTimeout = null;
  }
  activeMegaMenu.value = menu;
};

const scheduleMegaMenuHide = () => {
  megaMenuTimeout = setTimeout(() => {
    activeMegaMenu.value = null;
  }, 200);
};

const cancelMegaMenuHide = () => {
  if (megaMenuTimeout) {
    clearTimeout(megaMenuTimeout);
    megaMenuTimeout = null;
  }
};

const hideMegaMenuNow = () => {
  if (megaMenuTimeout) {
    clearTimeout(megaMenuTimeout);
    megaMenuTimeout = null;
  }
  activeMegaMenu.value = null;
};

const navigateAndClose = (href: string) => {
  hideMegaMenuNow();
  pageState.public_expanded = false;
  if (href.startsWith('/')) {
    const [path, hash] = href.split('#');
    const currentPath = route.path;
    if (hash && path === currentPath) {
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      router.push(href);
    }
  }
};

const onScroll = () => {
  if (window.scrollY > 0) {
    pageState.scrolled = true;
  } else {
    pageState.scrolled = false;
  }

  if (window.scrollY > 300) {
    pageState.scrolledMore = true;
  } else {
    pageState.scrolledMore = false;
  }
};

const toggleAction = () => {
  pageState.expanded = !pageState.expanded;
};
const toggleExpand = () => {
  pageState.profileContracted = !pageState.profileContracted;
  pageState.navbarExpanded = !pageState.navbarExpanded;
  pageState.expanded = !pageState.expanded;
};

onMounted(async () => {
  document.addEventListener('scroll', onScroll);

  await new Promise((resolve) => setTimeout(resolve, 500));

  pageState.initializing = false;
});

onBeforeUnmount(() => {
  unlockBodyScroll();
});

watch(
  () => pageState.public_expanded,
  (expanded) => {
    if (expanded) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  }
);

watch(
  () => route,
  () => {
    pageState.profileContracted = true;
    pageState.navbarExpanded = false;
    pageState.expanded = false;
    hideMegaMenuNow();
  },
  {
    deep: true,
  }
);
</script>

<style lang="scss" scoped>
.user-controls {
  position: fixed;
  right: 0px;
  top: 0px;
  z-index: 1001;
}

.scrolled .expanded-nav-item,
.not-home .expanded-nav-item {
  margin-top: calc(env(safe-area-inset-top) + 70px);
}

.expanded-nav-item {
  position: absolute;
  margin-top: calc(env(safe-area-inset-top) + 90px);
  top: 0px;
  left: 0;
  width: 100%;
  background-color: #fff0;

  pointer-events: none;
  transition: all 0.3s;
  z-index: 1;
  text-align: left;

  li {
    cursor: pointer;
    max-width: 300px;
  }

  ul {
    opacity: 0;
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: 0px !important;
  }

  h3 {
    font-size: 16px;
  }

  p {
    font-family: SharpGrotesk;
    font-size: 12px;
    font-weight: normal;
  }


}

.nav-link-text {
  position: relative;
  display: block;
  z-index: 3;
}

.expanded-nav-item:hover {
  background-color: white;
  pointer-events: all;

  ul {
    opacity: 1;
  }

}

.nav-item:hover .expanded-nav-item {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
}

.nav-item:hover a.nav-link-text {
  color: #00219e !important;
}


.expanded-nav-item li:hover {
  color: #00219e;
}

.nav-item.negative a {
  color: black !important;
}

.nav-item:hover .expanded-nav-item {
  pointer-events: all;
  background-color: white;

  ul {
    opacity: 1;
  }
}


.nav-container.hide {
  display: none;
}

.not-home.nav-container {
  margin-top: calc(70px);
}

.navbar {
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: space-between;
  height: calc(64px + env(safe-area-inset-top));
  z-index: 100;
  padding-top: env(safe-area-inset-top) !important;
}

.navbar-logo {
  position: fixed;
  top: 10px;
  left: 10px;
  opacity: 0;
  transition: all 0.3s;

  img {
    height: 54px;
    width: auto;
  }

  z-index: 1000;
}

.scrolled .navbar-logo,
.not-home .navbar-logo,
.home .navbar-logo {
  opacity: 1;
}

.scrolled-more .floating-logo {
  opacity: 1;
  transform: scale(1) rotate(0deg);
}

.nav-img {
  height: 48px;
  width: auto;
  margin-top: 0px;
}

.navbar-brand {
  transition: all 0.3s;
  padding: 0;
  margin: 0 24px;
}

.expand-icon {
  display: none;
  align-items: center;
  margin-right: 24px;
  cursor: pointer;

  .fa-solid.fa-bars,
  .bi.bi-plus-lg {
    position: relative;
    z-index: 1;
  }

  .nav-expand-btn {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 24px;
    position: relative;

    span {
      display: inline-block;
      width: 40px;
      height: 2px;
      background-color: #fff;
      border-radius: 2px;
    }

    &::before,
    &::after {
      content: ' ';
      display: inline-block;
      width: 40px;
      height: 2px;
      background-color: #fff;
      border-radius: 2px;
      position: absolute;
      left: 0;
      transition: all 0.3s;
    }

    &::before {
      top: 0px;
    }

    &::after {
      bottom: 0px;
    }

    &.expand {
      span {
        display: none;
      }

      &::before {
        top: 11px;
        transform: rotateZ(45deg);
      }

      &::after {
        bottom: 11px;
        transform: rotateZ(-45deg);
      }
    }
  }
}

.up-nav {
  background-color: rgba(63, 225, 184, 0);
  transition: 0.3s all;

  .position-relative {
    .bi.bi-chevron-down.text-white {
      display: inline-block;
      width: 12px;
      height: 8px;
    }

    .nav {
      .nav-item {
        display: inline-flex;
        align-items: center;
        justify-content: center;

        .nav-link {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          color: #fff;
          font-family: SharpGrotesk;
          position: relative;

          span {
            position: relative;
          }

          &:hover,
          &.router-link-active {
            font-size: 16px;

            & span {
              transform: translateY(-5px);

              &::after {
                content: ' ';
                display: inline-block;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 4px;
                transform: translateY(0.5rem);
                background-color: rgba(255, 201, 24, 1);
              }
            }
          }
        }
      }
    }

    .user-actions {
      display: inline-flex;
      align-items: center;
      cursor: pointer;

      .level-up-icon {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 40px;
        height: 40px;
        margin-right: 6px;
        background-color: #e9f3fc;
        border-radius: 50%;

        .svg-icon {
          font-size: 36px;
        }
      }

      .fa-regular.fa-angle-down {
        transition: all 0.3s;
      }

      &.expand {
        .fa-regular.fa-angle-down {
          transform: rotateZ(180deg);
        }
      }
    }
  }
}

.up-nav.scrolled,
.up-nav.navbar-expanded {
  background-color: rgba(0, 33, 158, 0.9);

  .nav-img {
    transform: scale(1);
  }

  .expand-icon {
    color: white;
  }
}

.navbar-collapse.collapse.show {
  border-top: 2px solid rgb(0, 0, 0, 0.1);
}

.nav-link {
  width: 100%;
  font-size: clamp(20px, 1.5vw, 40px);
  color: white;
  text-align: center;
}

.up-nav-collapse {
  border-width: 1px;
  border-color: rgb(0, 0, 0, 1);
}

.expand-icon {
  width: 40px;
  height: 40px;
  z-index: 1;

  .nav-expand-btn {
    z-index: 1;
  }
}

.scrolled-more nav {
  opacity: 1;
}

nav {
  transition: 0.3s all ease;
  font-family: 'SharpGrotesk';
  z-index: 999;
  text-align: right;

}

.logged-out-nav nav ul li {
  padding: 12px 15px;
}

.login-btn,
.signup-btn {
  display: inline-block;
  padding: 10px 10px;
  font-weight: bold;
  color: white;
  font-size: 16px;
  border: 2px solid rgba(255, 255, 255, 0);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.1s ease;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  transition: all 0.3s ease;
  margin-top: 12px;

  a {
    color: white;
    text-decoration: none;
  }
}

.home .signup-btn {
  margin-top: 28px;
}

.home .scrolled .signup-btn {
  margin-top: 12px;
}

.signup-btn {
  background-color: #ff4611;
  border-radius: 4px;
  margin: 0 20px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.login-btn:hover {
  border-color: rgba(255, 255, 255, 1);
}

.signup-btn:hover {
  filter: brightness(120%);
  box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 4px;
  transform: translateY(-2px);
}

.outer-login-btn {
  display: none;
}

.floating-nav {

  .nav-img {
    margin-top: env(safe-area-inset-top);
  }

  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: calc(80px + env(safe-area-inset-top));
  z-index: 999;
  transition: 0.3s all;
  box-shadow: #00000000 0px 0px 0px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    transition: 0.3s all;

    display: flex;
    flex-direction: row;
    align-items: center;

  }

  .nav-item a,
  .nav-item .nav-link-text {
    text-decoration: none;
    transition: 0.3s all;
  }
}

.floating-nav-inner {
  max-width: 1250px;
  margin: 0 auto;
  padding: calc(env(safe-area-inset-top) + 8px) 24px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.floating-nav-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  flex-shrink: 0;
  margin-left: -30px;

  img {
    height: 42px;
    width: auto;
  }
}

.nav-login a {
  font-weight: bold !important;
  color: #000 !important;
}

.has-dropdown {
  position: relative;
  cursor: default;

  > .nav-link-text {
    cursor: pointer;
  }
}

.nav-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  border: 1px solid #eee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  padding: 12px 0;
  min-width: 200px;
  max-width: 260px;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  pointer-events: none;

  a {
    display: block;
    padding: 8px 20px;
    font-family: 'SharpGrotesk';
    font-size: 14px;
    color: #444 !important;
    text-decoration: none;
    white-space: nowrap;
    transition: color 0.15s;
    margin-right: 0 !important;

    &:hover {
      color: #000 !important;
      background-color: #f5f5f5;
    }
  }
}

.has-dropdown:hover .nav-dropdown {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.home .floating-nav {
  height: calc(90px + env(safe-area-inset-top));
  background-color: #fff;
  backdrop-filter: blur(0px);
  -webkit-backdrop-filter: blur(0px);

  .nav-item a {
    color: black;

  }
}

.scrolled .floating-nav {
  height: calc(70px + env(safe-area-inset-top));
  box-shadow: 0px 1px 2px #00000033;

  .nav-item a {
    color: black;
  }

}

.home .scrolled .floating-nav {
  height: calc(70px + env(safe-area-inset-top));
  background-color: #ffffffdd;
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  box-shadow: 0px 1px 2px #00000033;

}

.not-home .floating-nav {
  height: calc(70px + env(safe-area-inset-top));
  background-color: white;

  .nav-item a {
    color: black;
  }

}

.floating-nav:hover {
  background-color: white;

  .nav-item {
    z-index: 2;
  }

  .nav-item a {
    color: black;
  }
}

.floating-nav {

  .nav-item,
  .login-btn,
  .signup-btn {
    pointer-events: auto;
  }
}

.open-nav-icon {
  position: fixed;
  top: calc(21px + env(safe-area-inset-top));
  right: 5px;
  width: 40px;
  height: 40px;
  z-index: 1000;
  color: black;
  font-size: 30px;
  transition: 0.3s all;
  pointer-events: auto;
}

.home .open-nav-icon {
  color: black;
}

.scrolled .open-nav-icon {
  color: black;
}

.close-nav-icon {
  position: absolute;
  top: calc(18px + env(safe-area-inset-top));
  right: 18px;
  width: 40px;
  height: 40px;
  z-index: 1001;
  color: black;
  font-size: 30px;
}

.mobile-only {
  display: none;
}

.desktop-only {
  display: inherit;
}

.not-home.scrolled .floating-nav {
  box-shadow: 0px 1px 2px #00000033;
}

.no-auth-bg {
  .floating-logo {
    opacity: 1;
    top: 5px;
    transform: rotate(0deg) translateY(5px);
  }

  .floating-nav {
    ul {
      margin-bottom: 30px;
    }
  }
}

.initializing * {
  transition: 0s all !important;
}

// ── Desktop mega-menu ─────────────────────────
@media (min-width: 1201px) {
  .has-dropdown .nav-dropdown {
    display: none !important;
  }
}

.mega-menu-overlay {
  display: none;
  position: fixed;
  top: calc(70px + env(safe-area-inset-top));
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 998;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(-6px);
  transition: opacity 0.22s ease, transform 0.22s ease, visibility 0.22s ease;
  border-top: 1px solid #eee;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);

  &.active {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transform: translateY(0);
  }
}

@media (min-width: 1201px) {
  .mega-menu-overlay {
    display: block;
  }
}

.mega-menu-container {
  max-width: 1250px;
  margin: 0 auto;
  padding: 56px 24px 80px;
}

.mega-cols {
  display: flex;
  gap: 64px;
}

.mega-left {
  flex: 1;
  display: flex;
  gap: 40px;
}

.mega-subcol {
  flex: 1;
  min-width: 0;
}

.mega-header {
  display: block;
  font-family: 'SharpGrotesk';
  font-size: 11px;
  font-weight: normal;
  color: #999;
  margin-bottom: 28px;
}

.mega-link {
  display: block;
  text-decoration: none;
  padding: 8px 0;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.6;
  }
}

.mega-link-title {
  display: block;
  font-family: 'SharpGrotesk';
  font-size: 15px;
  font-weight: normal;
  color: #000;
  margin-bottom: 4px;
  line-height: 1.3;
}

.mega-link-desc {
  display: block;
  font-family: 'SharpGrotesk';
  font-size: 13px;
  font-weight: normal;
  color: #888;
  line-height: 1.4;
}

.mega-right {
  flex: 1;
  min-width: 0;
}

.mega-cards {
  display: flex;
  gap: 24px;
}

.mega-card {
  flex: 1;
  min-width: 0;
  text-decoration: none;
  transition: opacity 0.15s;

  &:hover {
    opacity: 0.6;
  }
}

.mega-card-thumb {
  width: 100%;
  aspect-ratio: 16 / 10;
  background-color: #f0f0f0;
  margin-bottom: 14px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.mega-card-tag {
  display: block;
  font-family: 'SharpGrotesk';
  font-size: 11px;
  font-weight: normal;
  color: #999;
  margin-bottom: 6px;
}

.mega-card-title {
  display: block;
  font-family: 'SharpGrotesk';
  font-size: 15px;
  font-weight: bold;
  color: #000;
  line-height: 1.3;
}

.mega-card-subtitle {
  display: block;
  font-family: 'SharpGrotesk';
  font-size: 13px;
  font-weight: normal;
  color: #888;
  line-height: 1.4;
  margin-top: 4px;
}

@media (max-width: 1200px) {

  .hide-mobile {
    display: none !important;
  }

  .nav-dropdown {
    position: static;
    transform: none;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    box-shadow: none;
    border: none;
    padding: 4px 0 8px;
    min-width: 0;
    max-width: none;

    a {
      font-size: 16px !important;
      padding: 6px 0;
      color: #888 !important;
    }
  }

  .nav-item {
    height: auto;

    a,
    .nav-link-text {
      font-size: 20px;
    }
  }

  .nav-item:hover .expanded-nav-item {
    box-shadow: none;
  }

  .expanded-nav-item {
    margin-top: 10px !important;
    position: relative;
    display: block;

    ul {
      opacity: 1;

      h3 {
        font-size: 16px;
        font-weight: normal;
      }

      p {
        display: none;
      }
    }

    pointer-events: all;
  }

  .user-controls {
    display: none;
  }

  .outer-login-btn {
    pointer-events: auto;
    display: inline-block;
    position: absolute;
    top: calc(22px + env(safe-area-inset-top));
    right: 65px;

    a {
      color: white;
      text-decoration: none;
      padding: 15px;
      transition: 0.3s all;
    }
  }

  .scrolled .outer-login-btn,
  .not-home .outer-login-btn,
  .home .outer-login-btn {
    a {
      color: black;
    }
  }

  .desktop-only {
    display: none;
  }

  .nav-img {
    height: 45px;
    width: auto;
  }

  .floating-nav {
    pointer-events: all;
    background-color: white;
  }

  .floating-nav-inner {
    display: block;
    height: auto;
    padding: 0;
    max-width: none;
  }

  .floating-nav-logo {
    display: none !important;
  }

  .floating-nav nav {
    height: 0px;
    background-color: white;
    padding-top: 0px;
    overflow: hidden;

    ul {
      margin-right: 10px;
    }

    li {
      display: inline-block;
      padding: 0px;
      font-weight: bold;
      font-size: 12px;
    }
  }

  nav.expanded {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    height: 100dvh;
    padding-top: calc(80px + env(safe-area-inset-top));
    padding-bottom: env(safe-area-inset-bottom);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 999;
  }

  .home .nav-item a {
    color: black !important;
  }

  .floating-nav {

    height: calc(70px + env(safe-area-inset-top)) !important;

    ul {
      flex-direction: column;
      align-items: flex-start;
      margin: 10px !important;
      padding: 0;
    }

    li {
      text-align: left;
      margin: 0;
      margin-top: 8px;
    }

    .nav-login {
      order: -1;
    }
  }

  .mobile-only {
    display: inherit;
  }

  .navbar {
    box-shadow: none;
    height: calc(72px + env(safe-area-inset-top));
  }

  .header-nav-right {
    margin-right: 0 !important;

    .expand-icon {
      display: inline-flex;
    }

    .user-actions,
    ul {
      display: none !important;
    }
  }

  .navbar-logo {
    z-index: 998;
  }

  .navbar-brand {
    &.mobile-opacity-0 {
      opacity: 0;
    }
  }

}
</style>
